// AI-CONTEXT: See docs/features/msi-onderbouwing-transparency.md

// Human labels for the known bron types. Open enum: unknown types render
// their raw value instead of failing.
const TYPE_LABELS = {
    universeel: 'Tarief',
    literatuur: 'Literatuur',
}

/**
 * Renders one source citation from the meetstandaard onderbouwing. With a url
 * it becomes a link (title + publisher/year appended); without one it renders
 * as plain text with the note explaining why there is no public link. The
 * type badge distinguishes tariffs ("universele bronnen") from scientific
 * literature — the core of the transparency story.
 *
 * @param {object} props
 * @param {import('../../helpers/msiMonetisationHelpers/buildOnderbouwingIndex').OnderbouwingBron} props.bron - Resolved bron entry
 */
const BronLink = ({ bron }) => {
    const meta = [bron.publisher, bron.year].filter(Boolean).join(', ')
    const label = meta ? `${bron.title} (${meta})` : bron.title
    const typeLabel = TYPE_LABELS[bron.type] || bron.type

    return (
        <span className={`msi-onderbouwing-bron msi-onderbouwing-bron--${bron.type}`}>
            <span className='msi-onderbouwing-bron-type'>{typeLabel}</span>
            {bron.url ? (
                <a
                    className='msi-onderbouwing-bron-link'
                    href={bron.url}
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    {label}
                </a>
            ) : (
                <span className='msi-onderbouwing-bron-plain' title={bron.note || undefined}>
                    {label}
                    {bron.note && <span className='msi-onderbouwing-bron-note'>{bron.note}</span>}
                </span>
            )}
        </span>
    )
}

export default BronLink
